import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { GA4_MEASUREMENT_ID, gtagService } from './services/gtagService'
import './index.css'

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID || GA4_MEASUREMENT_ID
if (measurementId) gtagService.init(measurementId)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
